module.exports = __webpack_public_path__ + "static/media/25.71f79303.jpg";